var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_object-dps.js
 ** module id = ./node_modules/core-js/library/modules/_object-dps.js
 ** module chunks = 0
 **/